import { createAction, props } from '@ngrx/store';
import {
  OccupationDetail,
  OccupationForExportPdf
} from '@cpd-app/core-module/models';

export const loadOccupationDetail = createAction(
  '[OccupationDetail] Load Occupation Detail',
  props<{
    onetCode: string;
    jobId?: string;
    jobTitle?: string;
  }>()
);

export const reloadOccupationDetails = createAction(
  '[OccupationDetail] Reload Occupation Details'
);

export const reloadOccupationDetailsSuccess = createAction(
  '[OccupationDetail] Reload Occupation Details Success',
  props<{ occupationDetail: OccupationDetail }>()
);

export const occupationDetailWithBusinessRulesReady = createAction(
  '[OccupationDetail] Occupation Detail With Business Rules Ready',
  props<{ occupationDetail: OccupationDetail }>()
);

export const clearOccupationDetail = createAction(
  '[OccupationDetail] Clear Occupation Detail'
);

export const loadOccupationForExportPdf = createAction(
  '[OccupationDetail] Load Occupation For Export Pdf'
);

export const loadOccupationForExportPdfSuccess = createAction(
  '[OccupationDetail] Load Occupation For Export Pdf Success',
  props<{ occupation: OccupationForExportPdf }>()
);

/** The API answered cleanly, with no occupation for this code and job. */
export const loadOccupationFailed = createAction(
  '[OccupationDetail] Load Occupation Failed',
  props<{ onetCode: string; jobId?: string }>()
);

/** The load failed: GraphQL errors, or the request itself. Not "not found". */
export const loadOccupationError = createAction(
  '[OccupationDetail] Load Occupation Error',
  props<{ onetCode: string; jobId?: string }>()
);

/** A background reload of the page already shown failed. Changes nothing. */
export const reloadOccupationDetailsFailed = createAction(
  '[OccupationDetail] Reload Occupation Details Failed'
);

/**
 * Clears the detail only if it is still this page's (code review, 30 Sep).
 * A page leaving after the next page's resolver has run must not wipe the
 * next page's state.
 */
export const clearOccupationDetailFor = createAction(
  '[OccupationDetail] Clear Occupation Detail For',
  props<{ onetCode: string; jobId?: string }>()
);

export const clearOccupationForExportPdf = createAction(
  '[OccupationDetail] Clear Occupation For Export Pdf'
);
